import classes from "./FloatingButton.module.css";
import { useHistory } from "react-router-dom";

const FloatingButton = (props) => {
  const history = useHistory();

  const goBackHandler = (event) => {
    history.push("/");
  };

  return (
    <button onClick={goBackHandler} className={classes.fButton}>
      Back
    </button>
  );
};

export default FloatingButton;
